export default Object.freeze({
  Morning: 1,
  Afternoon: 2,
  Evening: 3
});
